const PaymentPanelEnum = {
    CONTACT: 'addresses',
    DISCOUNT: 'discount',
    PAYMENT: 'payment',
    VAT_TAX: 'vatTax',
};

export default PaymentPanelEnum;
